import {
  init as Sentry,
  replayIntegration,
  captureConsoleIntegration
  // reactRouterV6BrowserTracingIntegration
} from '@sentry/react';

/* import {
  useLocation,
  matchRoutes,
  BrowserRouter,
  useNavigationType,
  createRoutesFromChildren
} from 'react-router-dom'; */

import Store from '@/redux';
// import { useEffect } from 'react';
import { Provider } from 'react-redux';
import Application from '@/Application';
import { isStaging } from '@/utils/Location';
import { createRoot } from 'react-dom/client';
import { Theme, GlobalStyles } from '@/theme';

import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { sentryDSN, reCAPTCHA } from '@/utils/API';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getEnv, getEnvironment } from '@/utils/env';

!!sentryDSN &&
  Sentry({
    tracePropagationTargets: [`${getEnv('VITE_API_BASE_URL')}/api`],
    tracesSampleRate: +(getEnv('VITE_SENTRY_SAMPLE_RATE') ?? 0),
    environment: getEnvironment(),
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    dsn: sentryDSN,

    integrations: [
      replayIntegration(),

      captureConsoleIntegration({
        levels: getEnv('VITE_SENTRY_LOG_CAPTURE_LEVELS')?.split(', ')
      })

      /* reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }) */
    ],

    ignoreErrors: [
      'Non-Error promise rejection captured',
      'McD Bridge already initialized',
      'Non-Error exception captured'
    ]
  });

const ApplicationWrapper = (
  <Provider store={Store}>
    <ThemeProvider theme={Theme}>
      <GlobalStyles />

      <BrowserRouter basename="/homepage">
        <Application />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

createRoot(document.getElementById('root') as HTMLElement).render(
  reCAPTCHA ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCAPTCHA} useEnterprise>
      {ApplicationWrapper}
    </GoogleReCaptchaProvider>
  ) : (
    ApplicationWrapper
  )
);

(function () {
  if (!isStaging) return;
  const script = document.createElement('script');

  script.src =
    'https://cdnjs.cloudflare.com/ajax/libs/eruda/3.4.1/eruda.min.js';

  script.onload = () => (window as Application).eruda?.init();
  document.head.append(script);
})();
